import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import {OutlineButton, SectionTitle, ValueTitle} from "../Kit/Kit";

const StyledBodyContainer = BodyContainer.extend``;

const PositionContainer = styled.div`
  display: flex;
  box-shadow: 0 0 18px 0 #edf2f7;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: auto auto 16px;
  padding: 30px;
  
  :hover {
    background: #90d2e4;
    
    h1 {
      color: #fff;
    }
    
    button {
      background: #004a87;
      color: #fff;
    }
  }
`;

const Title = SectionTitle.extend`
  margin-bottom: 56px;
`;

const PositionText = ValueTitle.extend`
  color: #000;
  font-size: 16px;
  text-align: left;
`;

class OpenPositions extends React.Component {
    render() {
        const {onClick, jobData} = this.props;
        return (
          <StyledBodyContainer>
              <Title>Open Positions</Title>
              {
                  jobData.map(i => {
                      return (
                        <PositionContainer key={i.id}>
                            <PositionText>{i.position} ({i.location})</PositionText>
                            <OutlineButton onClick={() => onClick(i.id)}>Job Description</OutlineButton>
                        </PositionContainer>
                      )
                  })
              }
          </StyledBodyContainer>
        );
    }
}

export default OpenPositions;


// WEBPACK FOOTER //
// ./src/components/JoinOurTeam/OpenPositions.js